@if (errors$ | async; as errors) {
    @if (errors.notification) {
        <bs-alert [title]="errors.notification.title" [message]="errors.notification.message" [type]="alertType"></bs-alert>
    }
    @if (errors.tokenError) {
        <bs-alert [message]="errors.tokenError" [type]="alertType" (click)="messageClick($event)"></bs-alert>
    }
}
